module.exports = __webpack_public_path__ + "static/media/eg.ce676814.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/eg.svg
// module id = 2083
// module chunks = 0